"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestormAbilityHandler = exports.FirestormActorAbilityFactory = exports.FirestormAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class FirestormAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Firestorm;
        this.__typeName = "Firestorm";
    }
}
exports.FirestormAbilityArgs = FirestormAbilityArgs;
let FirestormActorAbilityFactory = class FirestormActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Firestorm", "AllEnemies", 2);
    }
};
FirestormActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Firestorm")
], FirestormActorAbilityFactory);
exports.FirestormActorAbilityFactory = FirestormActorAbilityFactory;
let FirestormAbilityHandler = class FirestormAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            attackType: "magic",
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 90)
                ],
                effects: [{
                        targetId,
                        duration: Duration_1.Duration.Turns(2),
                        effect: new core_1.BurningEffectArgs("Focus", 10)
                    }]
            })),
            onHitOrMiss: (sequence, { targetId }, { hit }) => sequence.push(new core_2.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "FireTornado"))
        });
    }
};
FirestormAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Firestorm)
], FirestormAbilityHandler);
exports.FirestormAbilityHandler = FirestormAbilityHandler;
